(function ($, window, document, undefined) {
    'use strict';
    $('#terms').wrapInner('<div class="terms-container"></div>')
    $('.terms-container').jScrollPane({ autoReinitialise: true });
    $('#terms').parent().find('a[data-target]').on('click', function (e) { e.preventDefault() });
})(window.jQuery, window, document);